module.exports = __webpack_public_path__ + "img/syukyaku-top-Z01sp.19dbaa0a.png";